import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from 'react-oidc-context';
import { AGREEMENTS_KEY, PROFILE_PICTURE_KEY, USER_KEY } from 'src/utils/constants/queryKeys';
import { ConfirmationModal } from './ConfirmationModal';
import { useNavigateWithSecureParams } from 'src/utils/hooks/useNavigateWithSecureParams';

interface NewDeviceModalProps {
  visible: boolean;
  hideNewDeviceModal: () => void;
}

const NewDeviceModal: React.FC<NewDeviceModalProps> = ({ visible, hideNewDeviceModal }) => {
  const queryClient = useQueryClient();
  const { clearParams } = useNavigateWithSecureParams();
  const auth = useAuth();
  const idToken = auth?.user?.id_token;
  const setupNewDevice = () => {
    console.log('setting new device...');
    queryClient.invalidateQueries({ queryKey: [AGREEMENTS_KEY, PROFILE_PICTURE_KEY, USER_KEY] });
    window.sessionStorage.clear();
    clearParams();
    auth.removeUser();
    auth.signoutRedirect({
      id_token_hint: idToken,
    });
  };

  return (
    <ConfirmationModal
      title="Set up a new device"
      confirmMessage="Are you sure you want to add a new device?"
      confirmText="YES"
      onCancel={hideNewDeviceModal}
      onConfirm={setupNewDevice}
      visible={visible}
    />
  );
};

export default NewDeviceModal;
